import { BillingAction, BillingActionType } from '../../actions/billingActions';
import { Usage } from '../../types/resources';

export const initialState = {} as Usage;

const usage = (state = initialState, action: BillingAction) => {
  switch (action.type) {
    case BillingActionType.GET_USAGE_OK: {
      return action.data;
    }
    case BillingActionType.UPDATE_USAGE_LIMIT_OK: {
      return {
        ...state,
        ...action.data,
      };
    }
    default:
      return state;
  }
};

export default usage;
